module.exports = __webpack_public_path__ + "static/media/admissions-infra-sports.95e08fbd.jpg";